import React from 'react';

export const ABIcon = ({
  fillColor = '#EEF9F9',
  size = '32',
  borderRadius = '16',
  boxShadow = '',
  currentColor = 'currentColor',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="32"
        height="32"
        rx={borderRadius}
        fill={fillColor}
        style={{
          boxShadow: boxShadow,
          backgroundColor: 'red',
        }}
      />
      <g clipPath="url(#clip0_1283_7418)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5 14C13.3284 14 14 13.3284 14 12.5C14 11.6716 13.3284 11 12.5 11C11.6716 11 11 11.6716 11 12.5C11 13.3284 11.6716 14 12.5 14ZM12.5 15C13.8807 15 15 13.8807 15 12.5C15 11.1193 13.8807 10 12.5 10C11.1193 10 10 11.1193 10 12.5C10 13.8807 11.1193 15 12.5 15ZM20.6033 10.6543C20.8083 10.4493 21.1407 10.4493 21.3457 10.6543C21.5507 10.8593 21.5507 11.1917 21.3457 11.3968L11.3968 21.3457C11.1918 21.5507 10.8594 21.5507 10.6543 21.3457C10.4493 21.1407 10.4493 20.8083 10.6543 20.6033L20.6033 10.6543ZM21 19.5C21 20.3284 20.3284 21 19.5 21C18.6716 21 18 20.3284 18 19.5C18 18.6716 18.6716 18 19.5 18C20.3284 18 21 18.6716 21 19.5ZM22 19.5C22 20.8807 20.8807 22 19.5 22C18.1193 22 17 20.8807 17 19.5C17 18.1193 18.1193 17 19.5 17C20.8807 17 22 18.1193 22 19.5Z"
          fill={currentColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_1283_7418">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(8 8)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
